export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/~/@ngx-translate/http-loader/index.js
// module id = ../../../../@ngx-translate/http-loader/index.js
// module chunks = 4